module.exports = __webpack_public_path__ + "static/media/geoportal.8cf6176f.png";